import React from 'react';
import LegalPdfPage from './LegalPdfPage';

const TermsOfService: React.FC = () => (
    <LegalPdfPage
        title="Términos de Servicio"
        iframeTitle="Términos de Servicio"
        pdfUrl="https://podscope.s3.us-east-1.amazonaws.com/legal/TyC.pdf"
    />
);

export default TermsOfService;
